<div style="width: 100%" class="editCode">
  <form [formGroup]="codeForm" (ngSubmit)="onSubmit()">

    @if (code.code) {
    <div class="form-group code-header">
      <div class="code-value">{{code.code}}</div>
    </div>
    }

    <div *ngIf="usingStencil" class="using-stencil">
      <label>Template:</label>
      <p>{{usingStencil}}</p>
    </div>

    <div class="form-group" [hidden]="code.stencil || code.kind != 'EDUCATION' || code.use_stencil_id">
      <label class="center-block">Template:
      </label>
      <mat-form-field appearance="outline" style="width: 100%;">
        <mat-select formControlName="use_stencil_id" (selectionChange)="onTemplateChange($event)">
          <mat-option [value]="" disabled>Please select...</mat-option>
          @for (item of stencils; track item) {
          <mat-option [value]="item.id">
            {{item.description}}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>

      @if (submitted && f.use_stencil_id.errors?.required) {
      <div class="invalid-feedback error">
        <div>Template required</div>
      </div>
      }
    </div>


    <div class="form-group">
      <label class="center-block">Description:
      </label>
      <input class="form-control" formControlName="description"
        [ngClass]="{ 'is-invalid': submitted && f.description.errors }" />
      @if (submitted && f.description.errors) {
      <div class="invalid-feedback error">
        @if (f.description.errors.required) {
        <div>Description Required</div>
        }
      </div>
      }

    </div>

    <div class="form-group" *ngIf="!code.stencil || code.code">
      <mat-checkbox formControlName="active">Active</mat-checkbox>
    </div>

    <div class="form-group" *ngIf="!code.stencil">
      <label class="center-block">Expected user count:
      </label>
      <input class="form-control" formControlName="expected_users"
        [ngClass]="{ 'is-invalid': submitted && f.expected_users.errors }" min="1" max="2000" step="1" type="number" />
      @if (submitted && f.expected_users.errors) {
      <div class="invalid-feedback error">
        @if (f.expected_users.errors.required) {
        <div>Expected user count required</div>
        }
      </div>
      }
    </div>

    <div class="form-group" *ngIf="!code.stencil">
      <label class="center-block">Expected completion date:
      </label>
      <input type="date" class="form-control" formControlName="expected_completion"
        [ngClass]="{ 'is-invalid': submitted && f.expected_completion.errors }" />
      @if (submitted && f.expected_completion.errors) {
      <div class="invalid-feedback error">
        @if (f.expected_completion.errors.required) {
        <div>Expected completion date required</div>
        }
        @if (f.expected_completion.errors.date) {
        <div>Valid Date Required</div>
        }
      </div>
      }
    </div>

    <div class="form-group" *ngIf="!code.stencil || code.code">
      <label class="center-block">Code expiry date (optional):
      </label>
      <input type="date" class="form-control" formControlName="expiry"
        [ngClass]="{ 'is-invalid': submitted && f.expiry.errors }" />
      @if (submitted && f.expiry.errors) {
      <div class="invalid-feedback error">
        @if (f.expiry.errors.notLessThanMaxDate) {
        <div>The expiry date of this code exceeds the client’s expiry date.
          Please update.</div>
        }
        @if (f.expiry.errors.date) {
        <div>Valid Date Required</div>
        }
      </div>
      }
    </div>


    @if (serverError) {
    <div class="invalid-feedback error">
      <div>{{serverError}}</div>
    </div>
    }

    <div style="margin-bottom: 1em;text-align:right;">
      <button type="submit" [disabled]="codeForm.pristine" class="btn btn-primary">
        Save
      </button>
      <button type="button" (click)="onCancel()" style="margin-left: 10px;" class="btn btn-secondary">Cancel</button>
      &nbsp;
    </div>
  </form>
</div>
